import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { ListInterface } from '@app/core/interfaces/list/list.interface';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

export enum MediaQueryState {
  Desktop,
  Tablet,
  Mobile,
  Undefined = -1,
}

export interface MediaQuery {
  mediaQueryState: MediaQueryState;
  breakpoint: string;
  query: string;
}

const mapBreakpoints = (breakpointState: BreakpointState): MediaQuery => {
  let mediaQueryState = MediaQueryState.Desktop;
  let breakpoint = GlobalService.desktopQuery;
  let query = GlobalService.ALL;

  for (const key in breakpointState.breakpoints) {
    if (breakpointState.breakpoints[key] === true) {
      switch (key) {
        case GlobalService.tabletQuery:
          mediaQueryState = MediaQueryState.Tablet;
          breakpoint = GlobalService.tabletQuery;
          query = GlobalService.TABLET;
          break;
        case GlobalService.mobileQuery:
          mediaQueryState = MediaQueryState.Mobile;
          breakpoint = GlobalService.mobileQuery;
          query = GlobalService.MOBILE;
          break;
      }
    }
  }

  return {mediaQueryState, breakpoint, query};
};
export type ScrollDirection = 'up' | 'down';

export interface ScrollData {
  scrollTop: number;
  scrollDirection: ScrollDirection;
}

@Injectable({providedIn: 'root'})
export class GlobalService {
  static desktopWidth = 1900;
  static tabletWidth = 991;
  static mobileWidth = 479;
  static ALL = 'all';
  static TABLET = 'max_width_991_px';
  static MOBILE = 'max_width_479_px';
  static desktopQuery = `all`;
  styleIfameParent: any;
  dataPaginator: ListInterface;
  selectPagePaginator: number;
  // static desktopQuery = `(min-width: ${GlobalService.tabletWidth + 1}px)`
  // static tabletQuery = `(max-width: ${GlobalService.tabletWidth}px) and (min-width: ${GlobalService.mobileWidth + 1}px)`
  // static mobileQuery = `(max-width: ${GlobalService.mobileWidth}px)`
  static tabletQuery = `(max-width: ${GlobalService.tabletWidth}px)`;
  static mobileQuery = `(max-width: ${GlobalService.mobileWidth}px)`;
  numberOfColumnsInTheList: 0;
  specialBlockUId: any;
  private static originStrukture: any;

  static setGlobalStruktureScripts(originStrukture: any) {
    GlobalService.originStrukture = originStrukture;
  }

  static getGlobalStruktureScripts() {
    return GlobalService.originStrukture;
  }

  paramsGlobalSearch: {
    inventoryWorksView: {
      pageNumber: number,
      typeView: string
    },
    archivedInventoryWorksView: {
      pageNumber: number,
      typeView: string
    },
    artistView: {
      pageNumber: number,
      typeView: string
    },
    articlesView: {
      pageNumber: number,
      typeView: string
    },
    exhibitionsView: {
      pageNumber: number,
      typeView: string
    }
  } = {
    inventoryWorksView: {pageNumber: 1, typeView: 'inventoryWorksView'},
    archivedInventoryWorksView: {pageNumber: 1, typeView: 'archivedInventoryWorksView'},
    artistView: {pageNumber: 1, typeView: 'artistView'},
    articlesView: {pageNumber: 1, typeView: 'articlesView'},
    exhibitionsView: {pageNumber: 1, typeView: 'exhibitionsView'},
  };

  optionSelect = {
    inventoryWorksView: 'sorting',
    artistView: 'sorting',
    exhibitionsView: 'sorting',
    news: 'sorting',
    articlesView: 'sorting',
  };

  mediaQuery = new BehaviorSubject<MediaQuery>(null);
  pageWidthSubject = new BehaviorSubject<number>(1900);
  scrollTopSubject = new BehaviorSubject<ScrollData>({scrollTop: 0, scrollDirection: 'up'});
  scrollDirectionSubject = new BehaviorSubject<ScrollData>({scrollTop: 0, scrollDirection: 'up'});
  runScrollHandlerTrigger = new BehaviorSubject<boolean>(false);
  // }
  private observeMediaQueries = [
    GlobalService.desktopQuery,
    GlobalService.tabletQuery,
    GlobalService.mobileQuery,
  ];

  constructor(breakpointObserver: BreakpointObserver) {
    this.breakpointObservable(breakpointObserver);
  }


  private _pageWidth = 1900;

  set pageWidth(value: number) {
    this._pageWidth = value;
    this.pageWidthSubject.next(value);
  }

  // static mediaQueries = {
  //   desktop: {
  //     minWidth: (GlobalService.tabletWidth + 1)
  //   },
  //   tablet: {
  //     minWidth: (GlobalService.mobileWidth + 1),
  //     maxWidth: GlobalService.tabletWidth
  //   },
  //   mobile: {
  //     maxWidth: GlobalService.mobileWidth
  //   },
  //   all: null
  // };

  // static getRwdModeByPageWidth(): RwdMode {
  //   if (GlobalService.pageWidth > GlobalService.tabletWidth) {
  //     return 'desktop';
  //   } else if (GlobalService.pageWidth <= GlobalService.tabletWidth
  //     && GlobalService.pageWidth > GlobalService.mobileWidth) {
  //     return 'tablet';
  //   } else if (GlobalService.pageWidth <= GlobalService.mobileWidth) {
  //     return 'mobile';
  //   }
  //   return 'desktop';

  private _scrollTop = 0;
  private _scrollDirection = 'up';
  public lastScrollDownPosition = 0;

  set scrollTop(value: number) {
    const scrollDirection: ScrollDirection = this._scrollTop < value ? 'down' : 'up';
    this._scrollTop = value;
    if (scrollDirection === 'down') {
      this.lastScrollDownPosition = value;
    }

    const v = {
      scrollTop: value,
      scrollDirection,
    };
    if (scrollDirection !== this._scrollDirection) {
      this._scrollDirection = scrollDirection;
      this.scrollDirectionSubject.next(v);
    }

    this.scrollTopSubject.next(v);
  }

  runScrollHandler() {
    this.runScrollHandlerTrigger.next(true);
  }

  private breakpointObservable(breakpointObserver: BreakpointObserver) {
    breakpointObserver
      .observe(this.observeMediaQueries)
      .pipe(map(mapBreakpoints))
      .subscribe((media) => this.mediaQuery.next(media));
  }
}
